import Swal from 'sweetalert2';

let lastDedupeKey = '';
let lastDedupeAt = 0;

/**
 * Non-blocking toast notifications (replaces legacy jQuery toastr, which breaks
 * under Vite/Rollup CJS interop with our CDN jQuery shim).
 */
/**
 * @param {object} [options]
 * @param {string} [options.html] If set, shown instead of `title` (allows links/buttons).
 * @param {string} [options.dedupeExtra] Appended to dedupe key when using custom html.
 */
export function displayToastrAlert(type, message, preventDuplicates, options) {
    preventDuplicates =
        typeof preventDuplicates !== 'undefined' ? preventDuplicates : false;
    options = options || {};

    if (
        type != 'success' &&
        type != 'info' &&
        type != 'warning' &&
        type != 'error'
    ) {
        type = 'info';
    }

    const dedupeKey =
        type +
        '\0' +
        message +
        '\0' +
        (options.dedupeExtra != null ? String(options.dedupeExtra) : '');
    const now = Date.now();
    if (
        preventDuplicates &&
        dedupeKey === lastDedupeKey &&
        now - lastDedupeAt < 600
    ) {
        return;
    }
    lastDedupeKey = dedupeKey;
    lastDedupeAt = now;

    const toastConfig = {
        toast: true,
        position: 'bottom',
        icon: type,
        showConfirmButton: false,
        timer: 7000,
        timerProgressBar: true,
    };

    if (options.html) {
        toastConfig.html = options.html;
    } else {
        toastConfig.title = message;
    }

    Swal.fire(toastConfig);
}
